import React from 'react';
import YouthDashboard from './YouthDashboard';

const Dashboard = () => {
  return <YouthDashboard />;
};

export default Dashboard;
